export function HomePageJsonLd() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '2026世界杯官网 ZL5.net',
    url: 'http://cefotiam.com/',
    description: '2026年国际足联世界杯官方信息聚合平台，聚合2026美加墨世界杯超清直播、实时赛事资讯、合规平台深度评测与福利活动精选。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://cefotiam.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '2026世界杯官网 ZL5.net',
    url: 'http://cefotiam.com/',
    description: '2026美加墨世界杯官方信息聚合与服务平台，提供超清直播导航、实时赛事资讯、合规平台评测及观赛指南。',
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '2026世界杯官网 - 首页',
    description: '2026美加墨世界杯官方信息聚合平台首页，聚合赛事直播、实时资讯、赛程赛果、平台评测与观赛指南等一站式服务。',
    url: 'http://cefotiam.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '2026世界杯官网',
      url: 'http://cefotiam.com/',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '2026年世界杯在哪些国家举办？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '2026年国际足联世界杯（第23届）由美国、加拿大和墨西哥三国联合主办，这是世界杯历史上首次由三个国家共同承办。比赛将在16座城市（美国11座、加拿大2座、墨西哥3座）的世界级体育场馆中举行。',
        },
      },
      {
        '@type': 'Question',
        name: '2026年世界杯有多少支参赛队伍？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '2026年世界杯将首次扩军至48支参赛球队，这是世界杯历史上参赛队伍最多的一届。小组赛将分为16个小组，每组3支球队，前两名晋级32强淘汰赛。',
        },
      },
      {
        '@type': 'Question',
        name: '2026年世界杯什么时候开始和结束？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '2026年世界杯将于6月11日（星期四）在墨西哥城阿兹特克体育场开幕，决赛将于7月19日（星期日）在纽约/新泽西大都会人寿体育场举行，整个赛事为期39天。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在线观看2026世界杯直播？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们推荐的合规直播平台均提供2026世界杯高清直播服务。您可以通过本站推荐的认证平台观看全部104场比赛的超清直播，部分平台还支持多角度回放和实时数据叠加功能。',
        },
      },
      {
        '@type': 'Question',
        name: 'ZL5.net是什么网站？安全吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'ZL5.net是2026世界杯官方信息聚合与服务平台，我们严格甄选并评测合规的在线观赛和投注平台，所有推荐平台均持有合法运营牌照。本站本身不提供投注服务，仅为用户提供安全入口导航和客观评测。',
        },
      },
      {
        '@type': 'Question',
        name: '如何购买2026世界杯门票？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '世界杯门票通过国际足联官方渠道发售。建议关注FIFA官网门票专区了解销售时间节点，一般分为抽签申请阶段、先到先得阶段和最后时刻销售阶段。我们会在资讯频道及时更新最新门票信息。',
        },
      },
      {
        '@type': 'Question',
        name: '2026世界杯的比赛用球有什么特点？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '2026世界杯官方比赛用球延续了高科技路线，内置精密传感器与惯性测量单元（IMU），可实时采集球的运动数据用于半自动越位判定。球的表面采用全新纹理设计以提升空气动力学性能，在高速飞行中更加稳定。',
        },
      },
      {
        '@type': 'Question',
        name: '本站推荐投注平台的优势是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们推荐的每个平台都经过严格的多维度评测，包括：合法牌照验证、资金安全保障、赔率竞争力、中文服务品质、提款速度、用户口碑等。并且我们与平台合作争取了世界杯专属的新人福利，通过本站注册可享受额外优惠。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
    </>
  );
}